import React from 'react';

const LoadingSpinner = ({ size = 'medium', text = 'Cargando...' }) => {
    const getSize = () => {
        switch (size) {
            case 'small': return '16px';
            case 'medium': return '24px';
            case 'large': return '40px';
            default: return '24px';
        }
    };

    const getFontSize = () => {
        switch (size) {
            case 'small': return '12px';
            case 'medium': return '14px';
            case 'large': return '16px';
            default: return '14px';
        }
    };

    return (
        <div style={{
            display: 'inline-flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: size === 'small' ? '4px' : '8px'
        }}>
            <div style={{
                width: getSize(),
                height: getSize(),
                border: '2px solid #f3f3f3',
                borderTop: '2px solid #007bff',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite',
                marginBottom: size === 'small' ? '2px' : '4px'
            }}></div>
            {text && (
                <span style={{
                    fontSize: getFontSize(),
                    color: '#666',
                    textAlign: 'center'
                }}>
                    {text}
                </span>
            )}

            <style>
                {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
            </style>
        </div>
    );
};

export default LoadingSpinner;